import { parseJSON } from '../../../utils/Helper';
import * as type from '../../constants';

const initialState = {

    loading: false,
    qmsFeedbackDetails: [],

    downloadLoader: false,

    error: null,
}

export function qmsFeedbackDetailsReducer(state = initialState, action) {
    switch (action.type) {

        case type.GET_QMS_FEEDBACK_DETAILs_DATA:
            return {
                ...state,
                loading: true,
            }
        case type.GET_QMS_FEEDBACK_DETAILs_DATA_SUCCESS:
            return {
                ...state,
                qmsFeedbackDetails: action.payload,
                loading: false,
                error: null
            }
        case type.GET_QMS_FEEDBACK_DETAILs_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.message,
                qmsFeedbackDetails: []
            }

        case type.DOWNLOAD_QMS_FEEDBACK_DETAILS_DATA:
            return {
                ...state,
                downloadLoader: true,
            }
        case type.DOWNLOAD_QMS_FEEDBACK_DETAILS_DATA_SUCCESS:
            return {
                ...state,
                downloadLoader: false,
            }
        case type.DOWNLOAD_QMS_FEEDBACK_DETAILS_DATA_FAILURE:
            return {
                ...state,
                downloadLoader: false,
            }

        default:
            return state
    }
}


